import React from 'react';

import ReactDOM from 'react-dom';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import $ from 'jquery';
import '@progress/kendo-theme-default/dist/all.css';

import { Button } from '@progress/kendo-react-buttons'

import { CommandCell } from './CommandCell.jsx';

import { process } from '@progress/kendo-data-query';

import { Tooltip } from '@progress/kendo-react-tooltip';

import { Input } from '@progress/kendo-react-inputs';
//import { Mainfilter } from './Mainfilter.jsx';
import {
    Grid, GridColumn as Column,
    GridColumnMenuFilter, GridToolbar,
    GridColumnMenuCheckboxFilter, GridDetailRow
} from '@progress/kendo-react-grid';

import { GridPDFExport } from '@progress/kendo-react-pdf';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import Lang from '../../lang'
import services from '../../services.js';
// import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';

// import esMessages from '../../lang/tlklang.json';

// import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
// import currencyData from 'cldr-core/supplemental/currencyData.json';
// import weekData from 'cldr-core/supplemental/weekData.json';

// import numbers from 'cldr-numbers-full/main/pt/numbers.json';
// import caGregorian from 'cldr-dates-full/main/pt-PT/ca-gregorian.json';
// import dateFields from 'cldr-dates-full/main/pt-PT/dateFields.json';
// import timeZoneNames from 'cldr-dates-full/main/pt-PT/timeZoneNames.json';
// import currencies from 'cldr-numbers-full/main/pt-PT/currencies.json';
import PDFGenerate from '../../components/tlelrik/table/pdfGenerate'
import CountUp from 'react-countup';
// load(
//     likelySubtags,
//     // currencyData,
//     weekData,
//     numbers,
//     currencies,
//     caGregorian,
//     dateFields,
//     timeZoneNames
// );

// loadMessages(esMessages, 'pt-PT');

var deleted = 0;

const startguoupsum = () => {
    // if (deleted === 0) {
    //     var cross = $(".k-i-group-delete").first()
    //     $(cross).trigger('click');
    //     deleted = 1;
    // }
}

const startguoup = {
    // onedelete: () => {
    //     startguoupsum();
    // }
}


let list = [];

let viewFor = '';

let castaKeyOrder = []

let columnlist = []

export class ColumnMenu extends React.Component {
    /*  Para renderizar o conteúdo html da página   */

    render() {
        return (
            <div>
                <GridColumnMenuFilter {...this.props} expanded={true} />
            </div>
        );
    }
}

export class ColumnMenuCheckboxFilter extends React.Component {
    /*  Para renderizar o conteúdo html da página   */

    render() {
        //console.log("list", list)
        return (
            <div>
                <GridColumnMenuCheckboxFilter {...this.props} data={list} expanded={true} />
            </div>
        );
    }
}

class ColumnHeaderToolTip extends React.Component {
    render() {
        return (
            <a className="k-link" onClick={this.props.onClick}>
            <span title={this.props.title}>{this.props.title}</span>
                {this.props.children}
            </a>
        );
    }
}

const Defaultstate = {
    take: 100,
    skip: 0,
    group: [],
    exporting: false
}

const customData = [
    { color: 'green' },
    { color: 'red' }
];

class DetailComponent extends GridDetailRow {
    /*  Para renderizar o conteúdo html da página   */
    render() {
        const dataItem = this.props.dataItem;
        const allParcelArrayObject = ["matrixArticle", "parcelProperty", "parcelExplorer", "legalFramework", "castaparc"]

        // console.log("jkdnxkjzn", this.props,columnlist)
        if (viewFor === 'vindima') {
            return (
                <div className="row">
                    {
                        columnlist.map((_row, i) => (
                            <div className="tab-section col-md-3" key={i}>
                                <div className="innerBox">
                                    <div className="display-content">
                                        <p><strong>{_row.field}({i + 1})</strong></p>
                                        <CountUp start={0} end={+dataItem[_row.field]} duration={6} />
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            );
        }
        else if (viewFor === 'casta') {
            return (
                <div>
                    <ul>
                        {
                            castaKeyOrder.map((_k, i) => (
                                (_k === 'Casta' || _k === 'Fator Castas' || _k === 'Percentagem' ||
                                    _k === 'Fator DO Porto' || _k === 'Cor' || _k === 'Tipo Casta' || _k === 'Sinónimo') &&
                                <li style={{ listStyleType: "none", marginBottom: "5px" }} key={i}>
                                    <strong>{Lang.langCheck.langRequest(_k)} :</strong>
                                    &nbsp;{_k === 'Tipo Casta' ? (dataItem[_k] == 'N' ? "Douro : N" : "Porto : S") : dataItem[_k]}
                                </li>
                            ))
                        }
                    </ul>
                </div>
            )
        } else if (viewFor === 'parcelversions') {
            return (
                <div className="parcelversions" >
                    {
                        JSON.stringify(dataItem.bothRow.base.parcel) !== JSON.stringify(dataItem.bothRow.next.parcel) &&
                        <div className="row">
                            <b>Parcel ({Lang.langCheck.langRequest("Update")})</b>
                            <div className="col-md-12">
                                <div className="row innertable">
                                    <div className="col-md-4 headerrows">
                                        <b>{Lang.langCheck.langRequest("Key Name")}</b>
                                    </div>
                                    <div className="col-md-4 headerrows">
                                        <b>{Lang.langCheck.langRequest("Previous Value")}</b>
                                    </div>
                                    <div className="col-md-4 headerrows">
                                        <b>{Lang.langCheck.langRequest("New Value")}</b>
                                    </div>
                                    {
                                        Object.keys(dataItem.bothRow.base.parcel).map((_k) => (
                                            dataItem.bothRow.base.parcel[_k] !== dataItem.bothRow.next.parcel[_k] &&
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        {_k}
                                                    </div>
                                                    <div className="col-md-4">
                                                        {
                                                            dataItem.bothRow.base.parcel[_k]
                                                        }
                                                    </div>
                                                    <div className="col-md-4">
                                                        {dataItem.bothRow.next.parcel[_k]}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {
                        allParcelArrayObject.map((modulename) => (
                            JSON.stringify(dataItem.bothRow.base[modulename]) !== JSON.stringify(dataItem.bothRow.next[modulename]) &&
                            <>
                                {
                                    dataItem.bothRow.base[modulename].length < dataItem.bothRow.next[modulename].length &&
                                    <div className="row">
                                        <b>{Lang.langCheck.langRequest(modulename)} {Lang.langCheck.langRequest("Add")} ({dataItem.bothRow.next[modulename].length - dataItem.bothRow.base[modulename].length})</b>
                                        <div className="row innertable">
                                            {
                                                dataItem.bothRow.next[modulename].map((r, index) => (
                                                    dataItem.bothRow.base[modulename].length <= index &&
                                                    <>
                                                        {
                                                            Object.keys(r).map((rk) => (
                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            {rk}
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            {r[rk]}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            ))
                                                        }
                                                        <hr />
                                                    </>
                                                ))
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    dataItem.bothRow.base[modulename].length > dataItem.bothRow.next[modulename].length &&
                                    <div className="row">
                                            <b>{Lang.langCheck.langRequest(modulename)} {Lang.langCheck.langRequest("Delete")} ({dataItem.bothRow.base[modulename].length - dataItem.bothRow.next[modulename].length})</b>
                                        <div className="row innertable">
                                            {
                                                dataItem.bothRow.base[modulename].map((r, index) => (
                                                    dataItem.bothRow.next[modulename].length <= index &&
                                                    <>
                                                        {
                                                            Object.keys(r).map((rk) => (
                                                                <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        {rk}
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        {r[rk]}
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            ))
                                                        }
                                                        <hr />
                                                    </>
                                                ))
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    dataItem.bothRow.base[modulename].length === dataItem.bothRow.next[modulename].length &&
                                    <div className="row">
                                        <b>{Lang.langCheck.langRequest(modulename)} ({Lang.langCheck.langRequest("Update")})</b>
                                        <div className="col-md-12">
                                            <div className="row innertable">
                                                <div className="col-md-3 headerrows">
                                                    <b>{Lang.langCheck.langRequest("Row num")}</b>
                                                </div>
                                                <div className="col-md-3 headerrows">
                                                    <b>{Lang.langCheck.langRequest("Key Name")}</b>
                                                </div>
                                                <div className="col-md-3 headerrows">
                                                    <b>{Lang.langCheck.langRequest("Previous Value")}</b>
                                                </div>
                                                <div className="col-md-3 headerrows">
                                                    <b>{Lang.langCheck.langRequest("New Value")}</b>
                                                </div>
                                                {
                                                    dataItem.bothRow.base[modulename].map((row, i) => (
                                                        Object.keys(row).map((_k) => (
                                                            row[_k] !== dataItem.bothRow.next[modulename][i][_k] &&
                                                            <div className="col-md-12">
                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        {i + 1}
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        {_k}
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        {
                                                                            row[_k]
                                                                        }
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        {dataItem.bothRow.next[modulename][i][_k]}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        )
                                                        )
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }

                            </>
                        ))
                    }
                </div>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }
}


const intConst = {
    "idTpAbrigo" : 1,
    "percentagem" : 1,
    "idTpNaturTerr" : 1,
    "percentagem" : 1,
    "idTpPedregosidade" : 1,
    "percentagem" : 1,
    "linha1" : 1,
    "linha2" : 1,
    "linha3" : 1,
    "entreLinha1" : 1,
    "entreLinha2" : 1,
    "Forma" : 1,
    "Tipo" : 1,
    "Altura - 1º Arame (cm)" : 1,
    "idTpPortaEnxertos" : 1,
    "percentagem" : 1,
    "falhas" : 1,
    "bacelos" : 1,
    "enxertos1" : 1,
    "videiras2" : 1,
    "videiras3" : 1,
    "videiras4A25" : 1,
    "videirasMaior25" : 1,
}

class Main extends React.Component {
    gridPDFExport;
    _export;

    export = () => {
        let todownload = this.getOnlyData();
        this.setState({ exporting: true }, () => {
            this._export.save(todownload);
            this.ExportDone()
        });
    }
    exportPDF = () => {
        let todownload = this.getOnlyData();
        this.setState({ exporting: true }, () => {
            services.exportFiles.pdfDownloader(todownload, this.props.columnlist)
            this.ExportDone()
        });
    }

    ExportDone = () => {
        this.setState({ exporting: false });
    }

    getOnlyData = () => {
        let listarray = [...list]
        let final = [];
        listarray.map((_r, _i) => {
            if (Object.keys(_r).length > 0)
                final.push(_r);
        });
        return final;
    }


    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.createDataState(Defaultstate);
        this.CommandCell = CommandCell({
            rowbuttonAction: this.rowbuttonAction,
            actionbuttons: this.props.actionbuttons,
            deleteFunc: this.props && this.props.deleteFunc && this.props.deleteFunc
        });
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {

        let groupfield = [];
        let sumfields = {};
        if (this.props.date !== preProp.date) {
            deleted = 0;
            list = this.props.list;
            columnlist = this.props.columnlist
            viewFor = this.props.viewFor
            castaKeyOrder = this.props.castaKeyOrder
            let dataState = { ...this.state.dataState }
            dataState.group = this.props.groupfield;
            let aggregates = this.props.aggregates;
            if (aggregates) {
                const groups = dataState.group;
                if (groups) { groups.map(group => group.aggregates = aggregates); }
                aggregates.map((row, index) => (
                    sumfields[row.field] = row
                ))
            }
            // list = this.getNewListData(list);
            this.setState({
                data: process(list.slice(0), dataState),
                dataState: dataState,
                groupfield,
                sumfields,
                selectedDropDown : this.props.selectedDropDown || []
            });

        }
        // startguoup.onedelete();
    }

    handleInputBoletim = (e,row) => {
        let fieldName = e.target.name
        let value = null
        // if(intConst[fieldName]){
        //     value = !isNaN(+e.target.value) ? +e.target.value : ""
        // }else{
          value = e.target.value
        // }
        let selectedDropDown = [...this.state.selectedDropDown]
        if(this.props.modulename === 'boletimAbrigo' || this.props.modulename === 'boletimNaturezaTerreno' || this.props.modulename === 'boletimPedregosidade' || this.props.modulename === 'boletimPortaEnxertos' || this.props.modulename === "boletimModoConducao"){
            if(!selectedDropDown[row.index]) return
            else if(!value){
                selectedDropDown.map((el,ind) => ind > row.index && selectedDropDown.splice(ind,1))
                console.log("SElecetedDropDown",selectedDropDown)
            }
        }
        row[fieldName] = value 
        this.props.ActionPerform(this.props.modulename, row,fieldName,selectedDropDown)
    }

    handleBoletimWithDropDown = (e,row) => {
        let fieldName = e.target.name
        let value = null
        if(intConst[fieldName]){
            value = !isNaN(+e.target.value) ? +e.target.value : ""
        }else{
          value = e.target.value
        }
        let selectedDropDown = [...this.state.selectedDropDown]
        let filteredDropDownIndex = selectedDropDown.findIndex(el => el == e.target.value)
        
        if(filteredDropDownIndex < 0){         
            selectedDropDown[row.index] = value
            row[fieldName] = value 
            this.props.ActionPerform(this.props.modulename, row,fieldName, selectedDropDown)   
        }
    }

    getNewListData = (listdata) => {
        let newListData = []
        listdata.map(_r => {
            Object.keys(_r).map(_key => {
                if (_r[_key] === "null" || _r[_key] === "Null" || _r[_key] === null || _r[_key] === undefined || _r[_key] === '') {
                    _r[_key] = 'nd'
                }
                if (_r[_key] === true) {
                    _r[_key] = 'Sim'
                }
                if (_r[_key] === false) {
                    _r[_key] = 'Não'
                }
            })
            newListData.push(_r)
        });
        console.log("listData", this.props.modulename, listdata)
        return newListData
    }

    rowbuttonAction = (action, dataItem) => {
        this.props.ActionPerform(action, dataItem);
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        let dataState = { ...this.state.dataState }
        dataState.group = this.props.groupfield;
        list = this.props.list;
        columnlist = this.props.columnlist
        viewFor = this.props.viewFor
        castaKeyOrder = this.props.castaKeyOrder
        this.setState({
            dataState
        });

    }

    createDataState = (dataState) => {
        let groupfield = [];
        let sumfields = {}

        if (this.props.groupfield) {
            groupfield = this.props.groupfield;
        }

        let aggregates = this.props.aggregates;
        if (aggregates) {
            const groups = dataState.group;
            if (groups) { groups.map(group => group.aggregates = aggregates); }
            aggregates.map((row, index) => (
                sumfields[row.field] = row
            ))
        } else {
            // let aggregateKey=this.props.columnlist
            // let listFields = this.props.list[0]
            // Object.keys(this.props.columnlist).map(function(key) {
            //     if(typeof listFields[`${aggregateKey[key].field}`] === 'number'){
            //         aggregates.push({field:aggregateKey[key].field,aggregate: 'sum'})
            //     }
            // });
            // //console.log("aggregate",aggregates)
        }
        list = this.props.list;
        // list = this.getNewListData(list);
        return {
            data: process(list.slice(0), dataState),
            dataState: dataState,
            groupfield,
            sumfields,
            selectedDropDown : this.props.selectedDropDown || []
        };
    }

    dataStateChange = (event) => {
        this.setState(this.createDataState(event.data));
    }

    expandChange = (event) => {

        if (this.props.collepsview) {
            event.dataItem.expanded = !event.dataItem.expanded;
            this.forceUpdate();
        } else {
            event.dataItem[event.target.props.expandField] = event.value;
            this.setState({
                data: Object.assign({}, this.state.data),
                dataState: this.state.dataState
            });
        }
    }

    cellRender = (tdElement, cellProps) => {

        if(this.props.modulename === 'boletimAbrigo' || this.props.modulename === 'boletimNaturezaTerreno' || this.props.modulename === 'boletimPedregosidade'){
            if(cellProps.field === 'Classe'){
                return (<td>
                    <select
                        style={{ width: "100%" , height:"30px"}}
                        name={this.props.columnkeyMap[cellProps.field]}
                        disabled={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                        value={cellProps.dataItem[this.props.columnkeyMap[cellProps.field]] ||""}
                        onChange={(e, row) => this.handleBoletimWithDropDown(e, cellProps.dataItem)} >
                        <option value="">Selecione</option>
                        {
                            this.props.modulename === 'boletimAbrigo' ?
                            this.props.all_list && this.props.all_list.Abrigo && this.props.all_list.Abrigo.map((row,index) => (
                                <option key={index} value={row.idtpabrigo}>{row.descr}</option>
                            ))
                            :
                            this.props.modulename === 'boletimNaturezaTerreno' ?
                            this.props.all_list && this.props.all_list.Natureza && this.props.all_list.Natureza.map((row,index) => (
                                <option key={index} value={row.idtpnaturterr}>{row.descr}</option>
                            ))
                            :
                            this.props.modulename === 'boletimPedregosidade' &&
                            this.props.all_list && this.props.all_list.Pedregosidade && this.props.all_list.Pedregosidade.map((row,index) => (
                                <option key={index} value={row.idtppedregosidade}>{row.descr}</option>
                            ))
                            
                        }
                    </select>
                </td>);
            }
            if(cellProps.field === 'Percentagem'){
                return (<td> <Input 
                    maxLength={6}
                    type={"text"}
                    name={this.props.columnkeyMap[cellProps.field]}
                    readOnly={((this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1) || !this.state.selectedDropDown[cellProps.dataItem.index])? true : false}
                    value={cellProps.dataItem[this.props.columnkeyMap[cellProps.field]] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        if(this.props.modulename === 'boletimCompassoPlantacao'){
            if(cellProps.field === 'Linha 1 (cm)' || cellProps.field === 'Linha 2 (cm)' || cellProps.field === 'Linha 3 (cm)' || cellProps.field === "Entrelinha 1 (cm)" || cellProps.field === "Entrelinha 2 (cm)"){
                return (<td> <Input type={"text"}
                    maxLength={6}
                    name={this.props.columnkeyMap[cellProps.field]}
                    readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                    value={ cellProps.dataItem[this.props.columnkeyMap[cellProps.field]] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        // if(this.props.modulename === 'artigoMatricial'){
        //     if(cellProps.field === 'Nº Artigo' || cellProps.field === 'Fração'){
        //         return (<td> <Input type={"text"}
        //             name={cellProps.field}
        //             readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
        //             value={ cellProps.dataItem[cellProps.field] ||""}
        //             onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
        //     }
        // }
        if(this.props.modulename === 'boletimDetalhesPovoamento'){
            console.log("propsps",cellProps)
            if(cellProps.field === 'Bacelos' || cellProps.field === 'Enxertos (1 ano)' || 
                cellProps.field === 'Falhas' || cellProps.field === "Videiras (2 anos)" || 
                cellProps.field === "Videiras (3 anos)" || cellProps.field === "Videiras (4-25 anos)" ||
                cellProps.field === "Videiras (> 25 anos)"){
                return (<td> <Input type={"text"}
                    maxLength={6}
                    name={this.props.columnkeyMap[cellProps.field]}
                    readOnly={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                    value={ cellProps.dataItem[this.props.columnkeyMap[cellProps.field]] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>
                );
            }
        }
        
        if(this.props.modulename === 'boletimModoConducao'){
            
            if(cellProps.field === 'Forma' || cellProps.field === 'Tipo'){
                return (<td>
                    <select
                        style={{ width: "100%" , height:"30px"}}
                        name={this.props.columnkeyMap[cellProps.field]}
                        disabled={(this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                        value={cellProps.dataItem[this.props.columnkeyMap[cellProps.field]] || ""}
                        onChange={cellProps.field === 'Forma' ? (e, row) => this.handleBoletimWithDropDown(e, cellProps.dataItem) : (e, row) => this.handleInputBoletim(e, cellProps.dataItem) } >
                        <option value="">Selecione</option>
                        {
                            cellProps.field === 'Forma' ?
                            this.props.all_list && this.props.all_list.Forms && this.props.all_list.Forms.map((row,index) => (
                                <option key={index} value={row.idtparmacao}>{row.descr}</option>
                            ))
                            :
                            cellProps.field === 'Tipo' &&
                            cellProps.dataItem.tipo && cellProps.dataItem.tipo.map((row,index) => (
                                <option key={index} value={row.idtparmacaoforma}>{row.descr}</option>
                            ))
                        }
                    </select>
                </td>);
            }

            if(cellProps.field === 'Altura - 1º Arame (cm)'){
                return (<td> <Input type={"text"}
                    name={this.props.columnkeyMap[cellProps.field]}
                    maxLength={6}
                    readOnly={!(this.state.selectedDropDown[cellProps.dataItem.index])? true : false}
                    value={ cellProps.dataItem[this.props.columnkeyMap[cellProps.field]] || ""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        if(this.props.modulename === 'boletimPortaEnxertos'){
            if(cellProps.field === 'Tipo'){
                return (<td>
                    <select
                        style={{ width: "100%" , height:"30px"}}
                        name={this.props.columnkeyMap[cellProps.field]}
                        disabled={(this.props.totalPercentage + Number(this.props.percentagemEnxertoPronto) >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1)? true : false}
                        value={cellProps.dataItem[this.props.columnkeyMap[cellProps.field]] || ""}
                        onChange={(e, row) => this.handleBoletimWithDropDown(e, cellProps.dataItem)} >
                        <option value="">Selecione</option>
                        {
                            this.props.all_list  && this.props.all_list.Portaenxertos && this.props.all_list.Portaenxertos.map((row,index) => (
                                <option key={index} value={row.idtpportaenxertos}>{row.descr}</option>
                            ))
                        }
                    </select>
                </td>);
            }
            if(cellProps.field === 'Percentagem (Tipo)'){
                return (<td> <Input type={"text"}
                    name={this.props.columnkeyMap[cellProps.field]}
                    maxLength={6}
                    readOnly={((this.props.totalPercentage >=100 && cellProps.dataItem.index == cellProps.dataItem.totalCount-1) || !this.state.selectedDropDown[cellProps.dataItem.index])? true : false}
                    value={ cellProps.dataItem[this.props.columnkeyMap[cellProps.field]] ||""}
                    onChange={(e, row) => this.handleInputBoletim(e, cellProps.dataItem)} /> </td>);
            }
        }
        else if (cellProps.rowType === 'groupFooter') {
            let row = this.state.sumfields[cellProps.field]
            if (row) {

                return (
                    <td className="GridsumField">
                        {cellProps.dataItem.aggregates[cellProps.field].sum}
                    </td>
                );
            }
            else {
                if (cellProps.field === "Número")
                    return (
                        <td className="GridsumField">
                            Total {cellProps.dataItem.field} :
                        </td>
                    );
            }
        }
        // else if(cellProps.rowType === 'groupHeader' && tdElement && cellProps.dataItem && tdElement.props.children){
        //     return (
        //         <td colSpan={tdElement.props.colSpan}>
        //           {cellProps.dataItem.field}
        //         </td>
        //     );
        // }
        else if (cellProps.rowType !== 'groupHeader') {
            if (cellProps.field === "Estado" && (cellProps.dataItem.status === 1 || cellProps.dataItem.status === "1" || cellProps.dataItem.status === "Active" || cellProps.dataItem.status === "active" || cellProps.dataItem.status === "a" ||
                cellProps.dataItem.Estado === "A")) {
                return (
                    <td className="text-active">
                        Ativo
                    </td>
                );
            } else if (cellProps.field === "Estado") {

                return (<td className="text-inactive"> Inativo </td>);
            } else
                if (cellProps.field === "Estado" && (cellProps.dataItem.status === 1 || cellProps.dataItem.status === "1" || cellProps.dataItem.status === "Active" || cellProps.dataItem.status === "active" || cellProps.dataItem.status === "a" ||
                    cellProps.dataItem.status === "A")) {
                    return (
                        <td className="text-active">
                            Ativo
                        </td>
                    );
                } else if (cellProps.field === "Estado") {
                    return (<td className="text-inactive"> Inativo </td>);
                }
                else if (cellProps.field === "Declaração") {
                    return (<td > {cellProps.dataItem["Declaração"] === 1 ? "Sim" : "Não"} </td>);
                } else if (cellProps.field === "Legalizável") {
                    return (<td > {cellProps.dataItem["Legalizável"] === 1 ? "Sim" : "Não"} </td>);
                } else if (cellProps.field === "Classe") {
                    return (<td > {cellProps.dataItem["Classe"] === 1 ? "A" : cellProps.dataItem["Classe"]} </td>);
                }
                else if (cellProps.field === "Atividade") {
                    return (<td > {cellProps.dataItem["Atividade"] === 'Create' ? "Novo" : cellProps.dataItem["Atividade"] === 'Update' ? 'Atualização' : cellProps.dataItem["Atividade"]} </td>);
                }
        }
        if (cellProps.dataItem[cellProps.field] === "") {
            return (<td >nd</td>)
        }
        return tdElement;
    }


    /*  Para renderizar o conteúdo html da página   */

    render() {
        const grid = (
            <div>
                <Tooltip openDelay={100} position="top" anchorElement="element">
                <Grid
                    id="datagrid"
                    data={this.state.data}
                    {...this.state.dataState}
                    onDataStateChange={this.dataStateChange}
                    style={{ height: '520px' }}
                    resizable={true}
                    reorderable={true}
                    //filterable={true}
                    sortable={true}
                    className={!!this.props.customClass ? this.props.customClass : '' }
                    pageable={!this.props.noFooter && true}
                    pageSize={100}
                    groupable={true}
                    //groupable={{ footer: 'visible' }}
                    detail={this.props.collepsview ? DetailComponent : null}
                    onExpandChange={this.expandChange}
                    expandField="expanded"
                    cellRender={this.cellRender}
                >
                    {
                        !this.props.noExport && this.props.list && this.props.list.length > 0 &&
                        <GridToolbar>
                            <Button
                                title="Export PDF"
                                primary={true}
                                className="btn-ivdp-primary download-pdf mt-3 mr-2 btn-sm float-right"
                                // onClick={this.exportPDF}
                                disabled={this.state.exporting}
                            >
                                {"Exportar para Pdf"}
                            </Button>
                            <Button
                                title="Export Excel"
                                primary={true}
                                className="btn-ivdp-primary mr-2 btn-sm mt-3 float-right"
                                onClick={this.export}
                                disabled={this.state.exporting}
                            >
                                {"Exportar para Excel"}
                            </Button>
                        </GridToolbar>
                    }
                    {
                        this.props.columnlist.map((_row, index) => (
                            _row.filter ?
                                
                                <Column width={(this.props.modulename === 'boletimDetalhesPovoamento' || this.props.modulename === 'modoDeConducao' ||
                                this.props.modulename === 'boletimCompassoPlantacao') && 200} title={_row.field} headerCell={ColumnHeaderToolTip}  key={index} field={_row.field} filter={_row.filter} columnMenu={this.props.noFilterShow ? '' : (_row.columnMenuType ? ColumnMenuCheckboxFilter : ColumnMenu)} />
                                :
                                <Column width={(this.props.modulename === 'boletimDetalhesPovoamento' || this.props.modulename === 'modoDeConducao' ||
                                this.props.modulename === 'boletimCompassoPlantacao') && 200} title={_row.field} headerCell={ColumnHeaderToolTip} key={index} field={_row.field} columnMenu={this.props.noFilterShow ? '' : (_row.columnMenuType ? ColumnMenuCheckboxFilter : ColumnMenu)} />
                        ))
                    }
                    {
                        (!this.props.notAction && !this.state.exporting) &&
                        <Column width={100} field={Lang.langCheck.langRequest("Action")} cell={this.CommandCell} />

                    }
                </Grid>
                {/* <Mainfilter
                    dataState={this.state.dataState}
                    onDataRecieved={this.dataRecieved}
                />  */
                }
                </Tooltip>
            </div>

        )
        return (
            // <LocalizationProvider language="pt-PT">
            //     <IntlProvider locale="pt-PT" >
            <>
                <PDFGenerate columnlist={this.props.columnlist} dataList={list} />
                <GridPDFExport
                    ref={pdfExport => this.gridPDFExport = pdfExport}
                    margin="1cm"
                >
                    {grid}
                </GridPDFExport>
                <ExcelExport
                    data={list}
                    ref={exporter => this._export = exporter}
                >
                    {grid}
                </ExcelExport>
            </>
            //     </IntlProvider>
            // </LocalizationProvider>

        );
    }

    pageChange = (event) => {
        this.setState(this.createState(event.page.skip, event.page.take));
    }

    createState(skip, take) {
        return {
            data: list.slice(skip, skip + take),
            skip: skip
        };
    }
}

export default Main;
